import Vue from 'vue';
import Vuelidate from 'vuelidate';
import {VueReCaptcha} from 'vue-recaptcha-v3';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faSpinner } from '@fortawesome/pro-light-svg-icons';

import Globals from './globals';

import App from './App.vue';
import router from './router';

Vue.use(Globals);
Vue.use(Vuelidate);
Vue.use(VueReCaptcha, {siteKey: '6Lc6GeoUAAAAAAKDrwsFC36EUY9veg4yHVF_lnRK'});

library.add(faSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
